import config from '../config/config.json';
import RestModel from './RestModel';
import translate from '../helpers/translateHelper';
import {reverseTransform} from '../transformers/nationalityTransformer';

const resourceName = 'nationalities';

export default {
    create: resource => RestModel.create(resourceName, reverseTransform(resource)),

    edit: resource => RestModel.edit(resourceName, reverseTransform(resource)),

    list: () => RestModel.list(`${resourceName}/${config.defaultLocale}`).then(l => l.map(i => translate(i))),

    read: id => RestModel.read(resourceName, id),

    remove: id => RestModel.remove(resourceName, id)
};
